import { DateObject } from 'react-multi-date-picker';

export const getWeekInitial = (date: DateObject) => {
  return [new DateObject(date).toFirstOfWeek(), new DateObject(date).toLastOfWeek()];
};
